import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import {
  notificationTemplateColors,
  notificationTemplateLabel,
  notificationTemplateOptions,
  notificationTypeColors,
} from 'apps/investment/constants/notification';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import { FilterFieldConfig } from 'common/dynamic-filter-form';
import { dateTimeCell, linkCell, userCell } from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/admin/notification-logs' }),
  },

  {
    accessorKey: 'code',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Code" />
    ),
  },

  {
    accessorKey: 'type',
    header: 'Type',
    cell: ({ getValue }) => {
      const value = getValue();
      return <Tag color={notificationTypeColors[value]}>{value}</Tag>;
    },
  },

  {
    accessorKey: 'template',
    header: 'Template',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <Tag color={notificationTemplateColors[value]}>
          {notificationTemplateLabel[value] || value}
        </Tag>
      );
    },
  },

  {
    accessorKey: 'sender',
    header: 'Sender',
  },

  {
    accessorKey: 'receiver',
    header: 'Receiver',
  },

  {
    accessorKey: 'user',
    header: 'User',
    cell: userCell,
  },

  {
    accessorKey: 'send_success',
    header: 'Send Success',
    cell: ({ row }) => {
      const sendSuccess = row.original.send_success;
      if (sendSuccess) {
        return (
          <Tooltip title={'Success'}>
            <CheckCircleOutlined style={{ color: 'green', fontSize: '20px' }} />
          </Tooltip>
        );
      }

      return (
        <Tooltip
          title={
            row.original.error_message ? row.original.error_message : 'Failed'
          }
        >
          <CloseCircleOutlined style={{ color: 'red', fontSize: '20px' }} />
        </Tooltip>
      );
    },
  },

  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Sent At" />
    ),
    cell: dateTimeCell,
  },

  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    cell: dateTimeCell,
  },
];

export const filterConfig: FilterFieldConfig[] = [
  {
    name: 'type',
    type: 'select',
    label: 'Type',
    placeholder: 'All',
    minWidth: '100px',
    options: [
      { value: 'email', label: 'Email' },
      { value: 'phone', label: 'Phone' },
      { value: 'inapp', label: 'In-App' },
    ],
    defaultValue: 'all',
  },
  {
    name: 'template',
    type: 'select',
    label: 'Template',
    placeholder: 'All',
    minWidth: '120px',
    options: notificationTemplateOptions,
    defaultValue: 'all',
  },
];
